(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);
    stateConfig.$inject = ['$stateProvider','APP'];
    function stateConfig($stateProvider,APP) {
    	$stateProvider
    	.state('other', {
            parent: 'profileForm',
            url: '/investigationForm/:investigationFormId/other',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            params: {
            	investigationFormId:null
            },
            views: {
                'dynamicViewForInvestigationForm': {
                    templateUrl: 'app/investigation/prospects/profile/investigation-form/other/other.html',
                    controller: 'OtherController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('profile.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('profile.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }],
                sectionIndex:['investigationFormIndexService','$timeout', function (investigationFormIndexService,$timeout) {
                	investigationFormIndexService.setInvestigationValue("otherForm");
                }]
            }
        });
    }
})();